import { Layout, Menu } from 'antd'
import type { MenuProps } from 'antd'
import { 
  DashboardOutlined, 
  GiftOutlined, 
  SettingOutlined, 
  TeamOutlined, 
  SwapOutlined, 
  BarChartOutlined, 
  TrophyOutlined,
  ClockCircleOutlined
} from '@ant-design/icons'
import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { dashboardRoutes, publicRoutes } from '../setup/config'
import { titles } from '../setup/messages'

interface IMenuItem {
  content: string,
  url: string,
  iconType?: string,
  children?: IMenuItem[]
}

const { Sider } = Layout
const menuItems: IMenuItem[] = [
  {
    content: titles.dashboard,
    iconType: 'dashboard',
    url: dashboardRoutes.dashboardPage
  },
  {
    children: [
      {
        content: titles.list,
        iconType: 'unordered-list',
        url: dashboardRoutes.giftsManagementPage
      },
      {
        content: titles.requests,
        iconType: 'ordered-list',
        url: dashboardRoutes.giftRequestsPage
      }
    ],
    content: titles.gifts,
    iconType: 'gift',
    url: 'gifts-menu'
  },
  {
    content: titles.transfers,
    iconType: 'transaction',
    url: dashboardRoutes.transfersPage
  },
  {
    content: titles.team,
    iconType: 'user',
    url: dashboardRoutes.teamManagementPage
  },
  {
    content: titles.statisticals,
    iconType: 'bar-chart',
    url: dashboardRoutes.statisticalsPage
  },
  {
    content: titles.topUsers,
    iconType: 'team',
    url: dashboardRoutes.usersTopPage
  },
  {
    content: titles.kudosStatistic,
    iconType: 'bar-chart',
    url: dashboardRoutes.kudosStatisticPage
  },
  {
    content: titles.timeTracking,
    iconType: 'clock',
    url: publicRoutes.timeTracking
  },
  {
    content: titles.settings,
    iconType: 'setting',
    url: dashboardRoutes.settingPage
  }
]

const getIcon = (iconType: string | undefined) => {
  const iconMap: { [key: string]: React.ReactNode } = {
    'dashboard': <DashboardOutlined />,
    'gift': <GiftOutlined />,
    'setting': <SettingOutlined />,
    'user': <TeamOutlined />,
    'transaction': <SwapOutlined />,
    'bar-chart': <BarChartOutlined />,
    'team': <TrophyOutlined />,
    'clock': <ClockCircleOutlined />,
    'unordered-list': <GiftOutlined />,
    'ordered-list': <GiftOutlined />
  }
  return iconType ? iconMap[iconType] || <DashboardOutlined /> : <DashboardOutlined />
}

const convertToMenuItems = (menuItems: IMenuItem[]): MenuProps['items'] => {
  return menuItems.map(item => {
    const { content, iconType, url, children } = item
    
    if (children && children.length > 0) {
      return {
        key: url,
        icon: getIcon(iconType),
        label: content,
        children: convertToMenuItems(children)
      }
    }

    return {
      key: url,
      icon: getIcon(iconType),
      label: <Link to={url}>{content}</Link>
    }
  })
}

const SidebarLayout: React.FC = () => {
  const location = useLocation()
  const activeRoute = location.pathname

  return (
    <Sider
      width={250}
      className="sidebar-container"
      style={{
        background: '#001529',
        boxShadow: '2px 0 8px rgba(0, 0, 0, 0.15)'
      }}
    >
      <div 
        className="logo-container"
        style={{
          height: '73px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          margin: '0 0 8px 0',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
        }}
      >
        <h1 
          style={{
            color: 'white',
            margin: 0,
            fontSize: '22px',
            fontWeight: 'bold',
            textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)'
          }}
        >
          🎉 Inmobi Kudos
        </h1>
      </div>
      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={[activeRoute]}
        items={convertToMenuItems(menuItems)}
        style={{
          border: 'none',
          background: 'transparent',
          height: 'calc(100vh - 89px)',
          overflowY: 'auto',
          overflowX: 'hidden'
        }}
      />
    </Sider>
  )
}

export default SidebarLayout
